import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fdb-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {

  constructor() { }

}
